'use strict';

exports.__esModule = true;
exports.styles = exports.ChatMessagesListView = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp; // import {
//   styles,
//   TableView,
// } from '../../../../view/List';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = require('material-ui/styles');

var _Object = require('../Object');

var _Object2 = _interopRequireDefault(_Object);

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _List = require('../../../../view/List');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ChatMessagesListView = exports.ChatMessagesListView = (_temp = _class = function (_TableView) {
  _inherits(ChatMessagesListView, _TableView);

  function ChatMessagesListView() {
    _classCallCheck(this, ChatMessagesListView);

    return _possibleConstructorReturn(this, _TableView.apply(this, arguments));
  } // getColumns() {
  //   const {
  //     ChatMessageLink,
  //     ChatRoomLink,
  //     UserLink,
  //     Grid,
  //   } = this.context;
  //   return [
  //     // {
  //     //   id: "id",
  //     // },
  //     {
  //       id: "id",
  //       label: "ID сообщения",
  //       renderer: (value, record) => {
  //         return record ? <ChatMessageLink
  //           object={record}
  //         /> : null;
  //       },
  //     },
  //     {
  //       id: "Room",
  //       label: "Название комнаты",
  //       renderer: (value, record) => {
  //         return value ? <ChatRoomLink
  //           object={value}
  //         /> : null;
  //       },
  //     },
  //     {
  //       id: "CreatedBy",
  //       label: "Автор сообщения",
  //       renderer: (value) => {
  //         return value ? <UserLink
  //           user={value}
  //         /> : null;
  //       },
  //     },
  //   ]
  // }


  ChatMessagesListView.prototype.renderContent = function renderContent() {
    var _this2 = this;

    var _props = this.props,
        _props$data = _props.data,
        loading = _props$data.loading,
        objectsConnection = _props$data.objectsConnection,
        classes = _props.classes;
    var _context = this.context,
        Grid = _context.Grid,
        updateChatMessageProcessor = _context.query.updateChatMessageProcessor;
    var messages = objectsConnection && objectsConnection.edges.map(function (_ref) {
      var node = _ref.node;
      return node;
    }) || [];

    var messagesList = _react2.default.createElement(Grid, {
      container: true
    }, messages.map(function (n) {
      return _react2.default.createElement(Grid, {
        key: n.id,
        item: true,
        xs: 12
      }, _react2.default.createElement(_Object2.default, {
        data: {
          object: n
        },
        mutate: function mutate(props) {
          return _this2.mutate(_extends({
            mutation: (0, _graphqlTag2.default)(updateChatMessageProcessor)
          }, props));
        }
      }));
    }));

    return _react2.default.createElement('div', {
      className: classes.root
    }, messagesList);
  };

  return ChatMessagesListView;
}(_List.TableView), _class.defaultProps = _extends({}, _List.TableView.defaultProps, {
  title: "Чат-сообщения"
}), _temp);
exports.styles = _List.styles;
exports.default = (0, _styles.withStyles)(_List.styles)(function (props) {
  return _react2.default.createElement(ChatMessagesListView, props);
});